module.exports = __webpack_public_path__ + "static/media/GBP.32da1246.svg";